import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {TableServiceAreaSearchModel} from "../table-service-area-search-model.service";

@Component({
    selector: "wbo-table-service-area-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TableServiceAreaMultiSelectEditControlComponent),
        provideSearchModel(TableServiceAreaSearchModel)
    ]
})
export class TableServiceAreaMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<TableServiceAreaSearchModel> {
    constructor(model: TableServiceAreaSearchModel, injector: Injector) {
        super(model, injector, "tableServiceArea", "tableServiceArea");
    }
}
